@if (showPopup) {
  <div class="w-full fixed bottom-0 z-50 pointer-events-none p-6">
    <div class="referral-popup-panel mx-auto w-full sm:max-w-[840px] flex flex-col px-6 relative pb-8 pt-10 pointer-events-auto">
      <button
        class="absolute right-4 top-4 cursor-pointer text-gray-600 hover:text-gray-900"
        (click)="dismiss()"
        aria-label="Close"
      >
        <fa-icon [icon]="faX" class="text-base h-6 w-6 inline-block" />
      </button>

      <div class="mb-6">
        <h4 class="text-2lg text-vis-dark font-extrabold text-gray-900 mb-[.5rem]">Give $10, Get up to $100</h4>
        <p class="text-base text-vis-subtle">Share your unique link and you could earn up to $100 every time a friend signs up.</p>
      </div>

      <div class="md:flex md:flex-wrap md:gap-3">
        <div
        class="flex items-center rounded-xl border border-visBtn-disabled bg-white px-3 h-[3.75rem] mb-3 w-full md:max-w-[calc(100%-11.5rem)]"
        aria-label="Your referral link"
      >
        <span class="flex-1 text-sm text-vis-dark truncate">{{ referralLink }}</span>
        <button
          class="ml-2 cursor-pointer text-gray-500 hover:text-gray-800 flex-shrink-0"
          (click)="copyReferralLink()"
          [attr.aria-label]="urlCopied ? 'Copied!' : 'Copy link'"
        >
          @if (urlCopied) {
            <span class="text-xs font-medium text-ace-pink-600">Copied!</span>
          } @else {
            <fa-icon [icon]="faCopy" />
          }
        </button>
      </div>

      <button
        id="raf-trigger"
        type="button"
        class="w-full md:max-w-[10rem] h-[3.75rem] cursor-pointer inline-flex items-center justify-center rounded-full bg-ace-pink-600 hover:bg-ace-pink-700 text-white font-bold"
      >
        Share Link
      </button>
      </div>
    </div>
  </div>
}
